(() => {
  document.querySelectorAll('.dp-prisjakt-review').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open || document.getElementById('checkout-rating-script')) return;
      const stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = 'https://cdn.pji.nu/b2b/widgets/checkout-rating/index.css';
      document.head.append(stylesheet);
      const script = document.createElement('script');
      script.id = 'checkout-rating-script';
      script.src = 'https://cdn.pji.nu/b2b/widgets/checkout-rating/index.js';
      script.defer = true;
      document.head.append(script);
    });
  });
})();
